import React, {FC, useState} from 'react'
import {IProductProps, productActionType} from '../../cors/reducers'
import {useIntl} from 'react-intl'
import BarcodeBrowsingField from './BarcodeBrowsingField'
import debounce from 'lodash/debounce'
import {getCategoryAutoComplete} from '../../cors/_requests'
import SharedData from '../../../common/SharedData'

interface CategoryStepProps extends IProductProps {
  setIsPopupVisible?: (value: boolean) => void
}

const CategoryStep: FC<CategoryStepProps> = ({
  prodState,
  prodDispatch,
  setIsPopupVisible = () => {},
  currentStep,
  setCurrentStep,
}) => {
  const {formatMessage} = useIntl()
  const [dropdownOptions, setDropdownOptions] = useState<any[]>([])
  const {currentUser, language} = SharedData()

  const formatCategoryNames = (names: string) =>
    names
      .replace(/(?<!->)-/g, ' ')
      .replace(/\b\w/g, (m) => m.toUpperCase())
      .replace('&Amp;', '&')

  const debouncedFetch = debounce(async (value: string) => {
    try {
      const resp: any = await getCategoryAutoComplete(currentUser?.token, language, value)
      if (resp?.data?.message) {
        setDropdownOptions(
          resp.data.message.map((o: any) => ({...o, name: formatCategoryNames(o.name)})),
        )
      } else {
        setDropdownOptions([])
      }
    } catch {
      setDropdownOptions([])
    }
  }, 300)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target
    prodDispatch({type: productActionType.text, payload: {id: 'categoryName', value}})
    if (value.length > 1) debouncedFetch(value)
    else setDropdownOptions([])
  }

  const handleOptionClick = (option: any) => {
    setIsPopupVisible(false)
    prodDispatch({type: productActionType.text, payload: {id: 'categoryName', value: option.name}})
    prodDispatch({type: productActionType.text, payload: {id: 'categoryID', value: option.category_id}})
    setDropdownOptions([])
    if (setCurrentStep) setCurrentStep(2)
  }

  return (
    <div className='aps-cat-step'>
      {/* Quick search */}
      <div className='aps-cat-search-wrap'>
        <i className='fas fa-search aps-cat-search-icon' aria-hidden='true' />
        <input
          type='text'
          className='aps-cat-search-input'
          placeholder={formatMessage({id: 'search_for_category'}) || 'Search for a category…'}
          value={prodState.categoryName.value || ''}
          onChange={handleSearchChange}
          autoComplete='off'
        />
        {dropdownOptions.length > 0 && (
          <ul className='aps-cat-dropdown'>
            {dropdownOptions.map((option: any, idx: number) => (
              <li
                key={idx}
                className='aps-cat-dropdown-item'
                onMouseDown={() => handleOptionClick(option)}
              >
                {option.name}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Category grid browser */}
      <BarcodeBrowsingField
        prodState={prodState}
        prodDispatch={prodDispatch}
        handleChange={() => {}}
        setIsPopupVisible={setIsPopupVisible}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
    </div>
  )
}

export default CategoryStep
